import { ApiClient } from '@glomopay/utils';

import { env } from '@/config/env';
import { queryClient } from '@/config/query-client';
import { analytics, AnalyticsEventName, SessionErrorCode } from '@/features/analytics/public';
import { clearInvestorSession, getInvestorSession } from '@/features/investor-login/public';
import { logger } from '@/lib/logger';
import { redirectToLogin } from '@/shared/router/public';

const THIRTY_SECONDS_IN_MS = 30_000;

export const authedApiClient = new ApiClient(
  {
    baseURL: `${env.VITE_API_BASE_URL}/investor-portal`,
    timeout: THIRTY_SECONDS_IN_MS,
    enableCaseConversion: true,
    getAuthToken: () => getInvestorSession()?.token ?? null,
  },
  {
    401: () => {
      logger.info('investor session invalid', { reason: 'unauthorized' });
      if (getInvestorSession()) {
        analytics.track(AnalyticsEventName.INVESTOR_SESSION_FAILED, { error_code: SessionErrorCode.SESSION_EXPIRED });
        analytics.reset();
        analytics.setContext({ parent_merchant_id: undefined, color_scheme: undefined, color_scheme_source: undefined });
      }
      clearInvestorSession();
      queryClient.clear();
      redirectToLogin();
    },
  },
);
